import axios from 'axios';

export const userDeposit = (amount) =>
  axios.post('payment/deposit-organization', {
    amount,
  });

export const paymentDate = (id) => axios.get(`payment/payment-data?id=${id}`);

export const paymentHistory = () => axios.get(`payment/invoices?page=1&limit=500`);

export const purchaseUser = (data) => axios.post('payment/purchase-organization', data);

export const getTransferDetail = (transferCode, currentPage, rowsPerPage) =>
  axios.get(
    `payment/transfer-user-details?transfer_code=${transferCode}&page=${currentPage}&limit=${rowsPerPage}`,
  );
